import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader';

import { login, isLoggedIn, isAuthorized } from '../utils/AuthManager';
import { getEnvironment } from '../utils/LocalStorage';

import CsvTable from './CsvTable';
import NavigationBar from './NavigationBar';

class HomeView extends Component {
    state = {
        authorized: isAuthorized(),
        loaded: isLoggedIn()
    }
    componentWillMount() {
        const environment = getEnvironment();

        // if (!environment) {
        //     this.props.history.push('/configuration');
        //     return;
        // }

        if (!isLoggedIn()) {
            login(environment).then(() => {
                this.setState({ authorized: isAuthorized(), loaded: true });
            })
        }
    }
    render() {
        return (
            <div>
                <NavigationBar />
                <Loader loaded={this.state.loaded}>
                    {this.state.authorized ? (
                        <CsvTable />
                    ) : (
                            <h3>Insufficient privileges to access this application</h3>
                        )}
                </Loader>
            </div>
        )
    }
}

HomeView.propTypes = {
    history: PropTypes.object
};

export default HomeView;